import script from "./PriorFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./PriorFooter.vue?vue&type=script&setup=true&lang=js"

import "./PriorFooter.vue?vue&type=style&index=0&id=0dd1606e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dd1606e"]])

export default __exports__